import { buildPage } from 'page-builders/ArticlePage';

import {
  buildContentPropertyArticleProps,
  buildContentPropFooterLinks,
} from 'utils/article-helpers';
import FetchError from 'utils/fetch-error';
import { getContentPageRevalidationTime } from 'utils/config';

import { GraphQLClient } from 'graphql-request';

import {
  ArticlePageDocument,
  ArticlePagePathsDocument,
  type ArticlePage,
  type ArticlePageQuery,
} from 'queries/graphql';

// @lkuich - Confirm these are respected
const ignoredPaths = ['articles/rss.xml', 'reviews/rss.xml'];

export async function getStaticProps(context) {
  const endpoint = process.env.HASURA_ENDPOINT;
  const gqlClient = new GraphQLClient(endpoint, {
    headers: {
      'x-hasura-admin-secret': process.env.HASURA_GRAPHQL_ADMIN_SECRET,
    },
  });

  try {
    const { params, preview = null } = context;
    const { propertyId, category, collection, path } = params;

    if (ignoredPaths.includes(path)) {
      return {
        notFound: true,
      };
    }

    const articlePageQuery = await gqlClient.request<ArticlePageQuery>(ArticlePageDocument, {
      propertyId: Number(propertyId),
      category,
      collection,
      path,
    });

    // @ts-ignore - The sales page object is every field in the sales page query, we don't actually need every field. Would be nice to just get the sales page object Type from the query...
    const pageData: ArticlePage = articlePageQuery.articlePage?.[0];
    const contentPropertyProps = buildContentPropertyArticleProps(pageData);
    const links = buildContentPropFooterLinks(pageData.contentProperty);

    return {
      revalidate: getContentPageRevalidationTime(),
      props: {
        preview,
        pageData,
        links,
        contentPropertyProps,
      },
    };
  } catch (err) {
    if (err instanceof FetchError) {
      const { statusCode } = err;
      switch (statusCode) {
        case 404: {
          return {
            redirect: {
              destination: '/',
              permanent: false,
            },
          };
        }

        default: {
          throw err;
        }
      }
    }

    throw err;
  }
}

export async function getStaticPaths() {
  const endpoint = process.env.HASURA_ENDPOINT;
  const gqlClient = new GraphQLClient(endpoint, {
    headers: {
      'x-hasura-admin-secret': process.env.HASURA_GRAPHQL_ADMIN_SECRET,
    },
  });

  const articlePagePathsQuery = await gqlClient.request<ArticlePageQuery>(ArticlePagePathsDocument);

  const pages = articlePagePathsQuery.articlePage as ArticlePage[];

  const paths = pages.map(page => ({
    params: {
      propertyId: page.contentPropertyId.toString(),
      category: page.tag?.collection?.category?.slug,
      collection: page.tag?.collection?.slug,
      path: page.path,
    },
  }));

  return { paths, fallback: 'blocking' };
}

export default buildPage();
